// extracted by mini-css-extract-plugin
export default {"pageTitle":"iI5yf","title":"yo4lA","bordered":"QFroM"};